import { TagOption } from 'components/shared/Tags/model';
import { Underlying } from 'models/underlying';

export function useTags(
  tags: ReadonlyArray<TagOption<Underlying>>,
  onTagsChanged: (tags: ReadonlyArray<TagOption<Underlying>>) => void,
) {
  const onTagHighlightToggled = (labelToToggle: string) => {
    onTagsChanged(tags.map(tag => (tag.label === labelToToggle ? { ...tag, isHighlighted: !tag.isHighlighted } : tag)));
  };
  const onTagRemoved = (labelToRemove: string) => {
    onTagsChanged(tags.filter(tag => tag.label !== labelToRemove));
  };
  return { onTagHighlightToggled, onTagRemoved };
}
